import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchStockTakeLocationList = createAsyncThunk(
  "fetchStockTakeLocationList",
  async ({ keyword }) => {
    const token = localStorage.getItem("auth_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    const response = await axiosHttp.get(
      `stock-take/locations/all?keyword=${keyword}`,
      config
    );

    return response.data.data;
  }
);

const stockTakeLocationListSlice = createSlice({
  name: "stockTakeList",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
    page: 1,
    total: 0,
  },

  extraReducers: (builder) => {
    builder.addCase(fetchStockTakeLocationList.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(fetchStockTakeLocationList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.page = action.payload.page;
      state.total = action.payload.total;
    });
    builder.addCase(fetchStockTakeLocationList.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default stockTakeLocationListSlice.reducer;
